export default {
  apiGateway: {
    REGION: import.meta.env.VITE_AWS_REGION,
    URL: import.meta.env.VITE_BASE_URL
  },
  cognito: {
  //  REGION
    region: import.meta.env.VITE_AWS_COGNITO_REGION,
    //  USER_POOL_ID
    userPoolId: import.meta.env.VITE_USER_POOL_ID,
    //  APP_CLIENT_ID
    userPoolWebClientId: import.meta.env.VITE_USER_POOL_WEB_CLIENT_ID,
    //  IDENTITY_POOL_ID
    identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID
  }
}
